import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogTrigger,
    } from '@/components/ui/alert-dialog';
    import { useI18n } from 'vue-i18n';
    import { useMutation } from '@tanstack/vue-query';
    import axios from 'axios';
    import { toast } from 'vue-sonner';
    import type { Payroll } from '@/types';
    import { Button } from '@/components/ui/button';
    import { Minus } from 'lucide-vue-next';
    import { router } from '@inertiajs/vue3';
    import { ref, onMounted, onUnmounted, computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PayrollUnlockAlertDialog',
  props: {
    payroll: {},
    timeSinceApproval: {},
    isClient: { type: Boolean }
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const timeLeft = ref(Math.max(60 - Math.floor(props.timeSinceApproval), 0));
    let interval: ReturnType<typeof setInterval>;

    onMounted(() => {
        interval = setInterval(() => {
            if (timeLeft.value > 0) {
                timeLeft.value--;
            } else {
                clearInterval(interval);
            }
        }, 60000);
    });

    onUnmounted(() => {
        clearInterval(interval);
    });

    const isUnlockable = computed(() => {
        if (!props.isClient) return true;
        return timeLeft.value > 0;
    });

    const { mutate, isPending } = useMutation({
        mutationFn: () =>
            axios.post(
                route('v2.salary.payrolls.unlock', {
                    payroll: props.payroll.id,
                }),
            ),
        onSuccess: (data) => {
            toast.success(data.data.success || t('forms.general.success'));
            router.reload();
        },
        onError: (error: any) => {
            console.log('error', error);
            toast.error(error.response.data.error || t('forms.system_error'));
        },
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "ghost_destructive",
            size: "xs",
            width: "narrow",
            disabled: !isUnlockable.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('payrolls.edit.unlock')) + " ", 1),
              (_ctx.isClient)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(" + _toDisplayString(timeLeft.value) + " " + _toDisplayString(_unref(t)('payrolls.edit.mintues_short')) + ")", 1))
                : _createCommentVNode("", true),
              _createVNode(_unref(Minus), { class: "text-destructive" })
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }),
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('payrolls.unlock.title')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('payrolls.unlock.confirm')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('payrolls.unlock.no')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), {
                variant: "default",
                onClick: _unref(mutate)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('payrolls.unlock.yes')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})